import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative overflow-hidden pt-24 pb-16 md:pt-32 md:pb-24" data-id="element-39">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-40" />

      <div className="container mx-auto px-4 relative z-10 max-w-6xl" data-id="element-41">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-42">
          <div className="flex flex-col items-start text-left" data-id="element-43">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-sm font-medium mb-6" data-id="element-44">
              <span className="relative flex h-2 w-2" data-id="element-45">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75" data-id="element-46"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-500" data-id="element-47"></span>
              </span>
              Para mentes sobreestimuladas
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-50 leading-tight mb-6" data-id="element-48">
              Tu cerebro no está roto, solo tiene demasiado{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 drop-shadow-[0_0_15px_rgba(34,211,238,0.4)]" data-id="element-49">
                "ruido"
              </span>{' '}
              acumulado.
            </h1>

            <h2 className="text-xl md:text-2xl text-slate-300 font-medium leading-relaxed mb-8" data-id="element-50">
              El protocolo de 300 segundos para silenciar la parálisis por
              análisis y ejecutar tu primera tarea del día sin ansiedad.
            </h2>

            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 mb-8 relative overflow-hidden group" data-id="element-51">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/0 via-cyan-500/5 to-cyan-500/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" data-id="element-52" />
              <p className="text-slate-300 leading-relaxed" data-id="element-53">
                <span className="text-cyan-400 font-semibold" data-id="element-54">
                  Son las 9:15 AM.
                </span>{' '}
                Tienes el café en la mano y una lista de pendientes que parece
                una declaración de guerra. Miras la pantalla de la computadora,
                abres tres pestañas, las cierras, revisas el móvil y sientes ese
                nudo familiar en el pecho. No es pereza. Si fuera pereza,
                estarías disfrutando el descanso. Lo que sientes es una
                parálisis real que te agota antes de haber movido un solo dedo.
                Estás atrapado en el ruido de tu propio cerebro.
              </p>
            </div>

            <CTAButton data-id="element-55">ACCEDER AL MÉTODO AHORA</CTAButton>
            <p className="mt-4 text-sm text-slate-400 flex items-center gap-2" data-id="element-56">
              <span className="text-cyan-500" data-id="element-57">✓</span> Descarga instantánea.
              Empieza a silenciar el ruido en 2 minutos.
            </p>
          </div>

          <div className="relative lg:ml-auto w-full max-w-lg mx-auto" data-id="element-58">
            <div className="absolute -inset-4 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-2xl rounded-full opacity-50 animate-pulse" data-id="element-59" />
            <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-[0_0_40px_rgba(0,212,255,0.15)] bg-[#0A0A0F]" data-id="element-60">
              <img src="https://cdn.magicpatterns.com/uploads/xf9YcrEtCFHSFiMHXxrvbA/Untitled_design_(2).png" alt="Método Cero Ruido en laptop" className="w-full h-auto object-cover opacity-90 hover:opacity-100 transition-opacity duration-500" data-id="element-61" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0F] via-transparent to-transparent opacity-60" data-id="element-62" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}